// Generated by `yarn tokens:import --aos-ds` from the Figma "Radius" variables export. Do not edit.
//
// Keys are Figma's own aliases, holding the raw number Figma stores, in
// whatever unit that collection uses. `tailwind-preset.js` turns them into
// the Tailwind scale, so a class name and a Figma token are the same word.

export const radius = {
    'badge-round': 999,
    'badge-square': 2,
    'cards': 8,
    'common': 4,
    'focus-ring': 7,
    'message-mobile': 8,
    'message-web': 16,
} as const

export type RadiusAlias = keyof typeof radius
